<template>
  <div class="file-header">
    <div class="d-flex flex-grow flex-grow-1">
      <div class="file-icon">
        <i class="fa-light fa-file"></i>
      </div>
      <div class="header-file">
        <h4 class="file-name">
          {{ $store.state.template.metadata.name || $t("editor-header.file-name") }}
        </h4>
        <span class="file-status">
          <span>&#8212;</span>{{ unsavedChanges ? $t("editor-header.status-nosave") : $t("editor-header.status-save") }}
        </span>
        <button
          v-if="$store.state.unsavedChanges && !$store.state.editorIsDemoVersion"
          @click="saveChanges"
          id="save-template-btn"
          class="save-button btn btn-xs btn-primary btn-flex"
          :disabled="saving || $store.state.showingTemplateBackupInPreview"
        >
          <i class="fa-light fa-save"></i>
          {{ saving ? $t("editor-header.save-btn-saving") : $t("editor-header.save-btn-saved") }}
        </button>
        <span v-if="savingError" style="margin-left: 15px; color: #cd4b3d">{{ $t("editor-header.save-error") }}</span>
      </div>
    </div>

    <div class="actions" v-if="!$store.state.editorIsDemoVersion">
      <button
        @click="handleToggleHTML()"
        class="btn btn-xs"
        :tooltip="$store.state.showTooltips == true ? (!showRawHTML ? $t('sentence.raw') : $t('sentence.pretty')) : ''"
        tooltip-placement="bottom"
      >
        <div v-show="!showRawHTML">
          <i class="fa-light fa-code"></i>
        </div>
        <div v-show="showRawHTML">
          <i class="fa-light fa-code btn-active"></i>
        </div>
      </button>
      <ToggleButton
        class="comparison-btn"
        :text="$t('multiview.main-btn')"
        :onToggleButton="splitScreen"
        :value="comparisonView"
      />
    </div>
  </div>
</template>

<script>
import EventBus from "@/assets/js/eventBus.js";
import ToggleButton from "@/components/ToggleButton";
export default {
  name: "EditorHeader",
  props: {
    unsavedChanges: {
      type: Boolean,
    },
  },
  data() {
    return {
      saving: false,
      savingError: false,
      comparisonView: false,
      templateBackups: [],
      isDemo: true
    };
  },
  computed:{
    showRawHTML(){
      return this.$store.state.templatePreviewAsHTML
    }
  },
  methods: {
    saveChanges() {
      this.saving = true;
      this.savingError = false;
      this.$store.dispatch("saveTemplateChanges").then(
        () => {
          this.saving = false;
        },
        () => {
          this.saving = false;
          this.savingError = true;
        },
      );
    },
    splitScreen() {
      this.$emit("comparison-view");
    },
    enableComparisonView() {
      this.comparisonView = true;
    },
    disableComparisonView() {
      this.comparisonView = false;
    },
	handleToggleHTML(){
    this.$store.commit("toggleTemplatePreviewAsHTML")
		// this.showRawHTML = !this.showRawHTML
		// this.$emit("toggle-html")
	}
  },
  components: {
    ToggleButton,
  },
  mounted() {
    // EventBus.$on('save_quit', this.saveNQuit)
    EventBus.$on("comparison_view_on", this.enableComparisonView);
    EventBus.$on("comparison_view_off", this.disableComparisonView);
  },
};
</script>

<style lang="less" scoped>
.file-header {
  position: relative;
  height: 40px;
  // background-color: #F1F1F1;
  background-color: var(--alabaster);
  line-height: 40px;
  display: flex;
  flex-direction: row;

  .file-icon {
    margin-left: 80px;
    width: 12px;
  }

  .header-file {
    margin-left: 15px;
    display: flex;
    align-items: center;
    gap: 4px;
    .file-name {
      font-family: "Roboto", sans-serif !important;
      text-transform: unset !important;
      margin: 0;
    }
    .file-status {
      color: var(--charcoal-50);

      span {
        color: var(--charcoal);
        margin: 0 5px;
      }
    }

    .btn.btn-xs.btn-secondary {
      padding: 1px 0.5rem !important;
      margin-left: 15px;
    }
  }
  .data-btn {
    margin-left: auto;
    margin-right: 25px;

    button {
      background-color: #fafafa;
      border: none;
      color: #8f979c;
      font-weight: 500;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      font-size: 12px;
      border-radius: 0px !important;

      i {
        margin-right: 10px;
      }
    }
  }

  .actions {
    display: flex;
    gap: 12px;
  }
  .btn-active {
    color: var(--orange-web);
  }
}
</style>
